import { useState, useEffect } from 'react';
import questions from './questions.json';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Cookies from 'js-cookie';


export function SettingsButton() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [cookieContent, setCookieContent] = useState('');
  const [showDeleteButton, setShowDeleteButton] = useState(false)

  const openDialog = () => {
    var correctly_guessed = ""
    correctly_guessed = Cookies.get('correctly_guessed')
    if (typeof correctly_guessed === 'undefined') {
      correctly_guessed = ""
    }
    const guessed_before = correctly_guessed.split(";").filter(Number);
    var responseText = ""
    if (guessed_before.length > 0) {
      responseText = 'Eddig a következő ID-val rendelkező kérdéseket találtad ki: ' + guessed_before
      setShowDeleteButton(true)
    }
    else {
      responseText = 'Nem találtál még ki egy kérdést sem!';
      setShowDeleteButton(false)
    }
    setCookieContent(responseText);
    setDialogOpen(true);
  };

  const closeDialog = () => {
    setDialogOpen(false);
  };

  const eraseCookies = () => {
    Cookies.remove('correctly_guessed');
    setShowDeleteButton(false)
    setCookieContent('Minden találat törölve!');
  };

  return (
    <>
      <button
        id="settingsButton"
        type="button"
        className="btn btn-secondary"
        onClick={openDialog}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-gear"
          viewBox="0 0 16 16"
        >
          <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0" />
          <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z" />
        </svg>
      </button>
      <Dialog open={dialogOpen} onClose={closeDialog}>
        <DialogTitle>Beállítások</DialogTitle>
        <DialogContent>
          <p>{cookieContent}</p>
        </DialogContent>
        <DialogActions>
          {showDeleteButton &&
            <Button onClick={eraseCookies} color="primary">
              Mentett találatok törlése
            </Button>}
          <Button onClick={closeDialog} color="secondary">
            Bezárás
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

function MyButton({ action, type, onClick }) {
  var style = ""
  if (type == "primary") {
    style = "btn btn-primary"
  } else if (type == "secondary") {
    style = "btn btn-secondary"
  } else if (type == "success") {
    style = "btn btn-success"
  } else if (type == "danger") {
    style = "btn btn-danger"
  } else if (type == "warning") {
    style = "btn btn-warning"
  } else if (type == "info") {
    style = "btn btn-info"
  } else if (type == "light") {
    style = "btn btn-light"
  } else if (type == "dark") {
    style = "btn btn-dark"
  }
  return <button className={style} onClick={onClick}>{action}</button>
}

function Question({ value, id, style, onToggleStyle }) {
  const element_id = "question-" + id;
  return (
    <li>
      <span id={element_id} className={style} onClick={onToggleStyle}>
        {value}
      </span>
    </li>
  );
}

function Secret({ value }) {
  return (
    <>
      <h2>
        <span id="type">{value}</span>
      </h2>
    </>
  )
}

function Type({ value }) {
  return (
    <>
      <h2>
        <span id="type">{value}</span>
      </h2>
    </>
  )
}

function Card({ secret, type, questions, cardStyle, questionStyles, setQuestionStyles, setCardStyle }) {
  const toggleCardStyle = () => {
    setCardStyle((prevStyle) => (prevStyle === "blurred" ? "" : "blurred"));
  };

  const toggleQuestionStyle = (index) => {
    setQuestionStyles((prevStyles) =>
      prevStyles.map((style, i) =>
        i === index ? (style === "question blurred" ? "question" : "question blurred") : style
      )
    );
  };

  return (
    <div id="card">
      <div id="type-div">
        <Type value={type}></Type>
      </div>
      <div id="question-div">
        <ul>
          {questions.map((question, index) => (
            <Question
              key={index}
              value={question}
              id={index}
              style={questionStyles[index]}
              onToggleStyle={() => toggleQuestionStyle(index)}
            />
          ))}
        </ul>
      </div>
      <div id="secret-div" className={cardStyle} onClick={toggleCardStyle}>
        <Secret value={secret}></Secret>
      </div>
    </div>
  );
}

function removeAccents(str) {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
}

function levenshteinDistance(a, b) {
  const dp = Array.from({ length: a.length + 1 }, () => Array(b.length + 1).fill(0));

  for (let i = 0; i <= a.length; i++) dp[i][0] = i;
  for (let j = 0; j <= b.length; j++) dp[0][j] = j;

  for (let i = 1; i <= a.length; i++) {
    for (let j = 1; j <= b.length; j++) {
      if (a[i - 1] === b[j - 1]) {
        dp[i][j] = dp[i - 1][j - 1];
      } else {
        dp[i][j] = Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]) + 1;
      }
    }
  }

  return dp[a.length][b.length];
}

function similarity(a, b) {
  const distance = levenshteinDistance(a, b);
  const maxLen = Math.max(a.length, b.length);
  return (1 - distance / maxLen) * 100; // százalékos hasonlóság
}


export default function Page() {
  const [alertMessage, setAlertMessage] = useState(null); // Az Alert üzenet tárolása
  const [questionData, setQuestionData] = useState(null);
  const [cardStyle, setCardStyle] = useState("blurred"); // Secret alapállapota
  const [questionStyles, setQuestionStyles] = useState([]); // Kérdések alapállapota
  const [solved, setSolved] = useState(false)

  const randomNumberInRange = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  const makeAQuess = () => {
    var guess = prompt("Mi a tipped?")
    if (!guess) return;
    console.log(guess)
    var theSolution = removeAccents(questionData.solution)
    var theGuess = removeAccents(guess)
    console.log("Your guess: " + theGuess)
    console.log("Solution: " + theSolution)
    var guessResult = similarity(theGuess, theSolution)
    console.log("Your result is " + guessResult + "%")
    if (guessResult > 74) {
      setCardStyle('')
      setAlertMessage(<Alert severity="success">Szuper! A tipped {guessResult.toFixed(2)}%-ban helyes!</Alert>);

      var correctly_guessed = ""
      correctly_guessed = Cookies.get('correctly_guessed')
      if (typeof correctly_guessed === 'undefined') {
        correctly_guessed = ""
      }
      // console.log("Correctly guessed cookie before:" + correctly_guessed)
      // const myArray = correctly_guessed.split(";");
      // console.log(myArray.filter(Number) )
      var new_correctly_guessed_id = questionData.id
      correctly_guessed = correctly_guessed + ";" + new_correctly_guessed_id
      Cookies.set("correctly_guessed", correctly_guessed, { expires: 2 })
      console.log("Correctly guessed cookie after:" + correctly_guessed)

      setSolved(true)
    } else {
      setAlertMessage(<Alert severity="warning">Próbáld újra! A tipped csak {guessResult.toFixed(2)}%-ban helyes.</Alert>);
    }
    setTimeout(() => setAlertMessage(null), 5000);
  }

  const loadNextQuestion = () => {
    setSolved(false)

    var correctly_guessed = ""
    correctly_guessed = Cookies.get('correctly_guessed')
    if (typeof correctly_guessed === 'undefined') {
      correctly_guessed = ""
    }
    const guessed_before = correctly_guessed.split(";").filter(Number);
    console.log("Already guessed: " + guessed_before)
    
    while (true) {
      // ...
      var id = randomNumberInRange(0, questions.length - 1);
      // var id = randomNumberInRange(0, 10);
      if (guessed_before.includes(String(id))) {
        console.log("Random ID is already guessed.. (" + id + ")")
      } else {
        console.log("Random question ID: (" + id + ")")
        break;
      }
    }

    // Reset styles for secret and questions
    setCardStyle("blurred");
    if (questions[id]) {
      setQuestionStyles(Array(questions[id].questions.length).fill("question blurred"));
    }
    // Delay the loading of the new question
    setTimeout(() => {
      setQuestionData(questions[id]); // Új kérdés betöltése
    }, 200); // 200ms késleltetés
  };

  useEffect(() => {
    if (questions && questions.length > 0) {
      loadNextQuestion();
    }
  }, []);

  return (
    <>
      <div id="content">
        {questionData ? (
          <Card
            secret={questionData.solution}
            type={questionData.type}
            questions={questionData.questions}
            cardStyle={cardStyle}
            questionStyles={questionStyles}
            setQuestionStyles={setQuestionStyles}
            setCardStyle={setCardStyle}
          />
        ) : (
          <p>Adatok betöltése...</p>
        )}

        <div id="button-row">
          {!solved ?
            (
              <>
                <MyButton action="Passz" type="secondary" onClick={loadNextQuestion} />
                <MyButton action="Tippelek" type="primary" onClick={makeAQuess} />
              </>
            ) : (
              <MyButton action="Következő kérdés" type="success" onClick={loadNextQuestion} />
            )
          }
        </div>
        {alertMessage && <div className="alertdiv">{alertMessage}</div>}
      </div>
      <SettingsButton></SettingsButton>
    </>
  );
}